import { render, staticRenderFns } from "./termCondition.vue?vue&type=template&id=5028fdea&scoped=true&"
var script = {}
import style0 from "./termCondition.vue?vue&type=style&index=0&id=5028fdea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028fdea",
  null
  
)

export default component.exports